import { render, staticRenderFns } from "./ScrollFab.vue?vue&type=template&id=2c691843&"
import script from "./ScrollFab.vue?vue&type=script&lang=ts&"
export * from "./ScrollFab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports